import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

// popup for Date/Time Fields when opening Calendar / DigitalClock
export const flowPickerPopper: Components<Theme>['MuiPickerPopper'] = {
  styleOverrides: {
    paper: ({ theme }) => ({
      boxShadow: theme.flowShadows.l,
    }),
  },
};
